function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.59362 0.167358H27.6145C28.9953 0.167358 30.125 1.25548 30.125 2.63655V18.6235C30.125 20.0046 28.9953 21.1764 27.6145 21.1764H17.8656V25.3197H24.9786C26.0246 25.3197 26.1083 28.7514 26.2338 28.877H4.01621C4.01621 28.877 4.01621 25.3197 5.27144 25.3197H12.3844V21.1764H2.59362C1.21287 21.1764 0.125 20.0046 0.125 18.6235V2.63655C0.125 1.25548 1.21287 0.167358 2.59362 0.167358ZM2.59362 18.6235H27.6145V2.63655H2.59362V18.6235Z",
  fill: "white"
});

var SvgLive = function SvgLive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live.8d60fee0.svg";
export { ForwardRef as ReactComponent };